/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoomSummaryV3 } from './RoomSummaryV3';
import {
    RoomSummaryV3FromJSON,
    RoomSummaryV3FromJSONTyped,
    RoomSummaryV3ToJSON,
    RoomSummaryV3ToJSONTyped,
} from './RoomSummaryV3';
import type { RecommendationSummary } from './RecommendationSummary';
import {
    RecommendationSummaryFromJSON,
    RecommendationSummaryFromJSONTyped,
    RecommendationSummaryToJSON,
    RecommendationSummaryToJSONTyped,
} from './RecommendationSummary';
import type { RatesSummary } from './RatesSummary';
import {
    RatesSummaryFromJSON,
    RatesSummaryFromJSONTyped,
    RatesSummaryToJSON,
    RatesSummaryToJSONTyped,
} from './RatesSummary';

/**
 * Per-source rate batch. Fires once for each rate source whose terminal
 * status arrives. `additional_rates` carries the raw room/rate items
 * from that source; `rates_summary` and `recommendation_summary` are
 * recomputed against the cumulative rate set so the client can refine
 * its summary panels progressively.
 * 
 * @export
 * @interface HotelRateStreamRates
 */
export interface HotelRateStreamRates {
    /**
     * 
     * @type {string}
     * @memberof HotelRateStreamRates
     */
    type: HotelRateStreamRatesTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof HotelRateStreamRates
     */
    source: HotelRateStreamRatesSourceEnum;
    /**
     * 
     * @type {Array<RoomSummaryV3>}
     * @memberof HotelRateStreamRates
     */
    additionalRates: Array<RoomSummaryV3>;
    /**
     * 
     * @type {RatesSummary}
     * @memberof HotelRateStreamRates
     */
    ratesSummary?: RatesSummary;
    /**
     * 
     * @type {RecommendationSummary}
     * @memberof HotelRateStreamRates
     */
    recommendationSummary?: RecommendationSummary;
}


/**
 * @export
 */
export const HotelRateStreamRatesTypeEnum = {
    Rates: 'rates'
} as const;
export type HotelRateStreamRatesTypeEnum = typeof HotelRateStreamRatesTypeEnum[keyof typeof HotelRateStreamRatesTypeEnum];

/**
 * @export
 */
export const HotelRateStreamRatesSourceEnum = {
    Travelport: 'travelport',
    Direct: 'direct',
    Liteapi: 'liteapi'
} as const;
export type HotelRateStreamRatesSourceEnum = typeof HotelRateStreamRatesSourceEnum[keyof typeof HotelRateStreamRatesSourceEnum];


/**
 * Check if a given object implements the HotelRateStreamRates interface.
 */
export function instanceOfHotelRateStreamRates(value: object): value is HotelRateStreamRates {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('additionalRates' in value) || value['additionalRates'] === undefined) return false;
    return true;
}

export function HotelRateStreamRatesFromJSON(json: any): HotelRateStreamRates {
    return HotelRateStreamRatesFromJSONTyped(json, false);
}

export function HotelRateStreamRatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelRateStreamRates {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'source': json['source'],
        'additionalRates': ((json['additional_rates'] as Array<any>).map(RoomSummaryV3FromJSON)),
        'ratesSummary': json['rates_summary'] == null ? undefined : RatesSummaryFromJSON(json['rates_summary']),
        'recommendationSummary': json['recommendation_summary'] == null ? undefined : RecommendationSummaryFromJSON(json['recommendation_summary']),
    };
}

export function HotelRateStreamRatesToJSON(json: any): HotelRateStreamRates {
    return HotelRateStreamRatesToJSONTyped(json, false);
}

export function HotelRateStreamRatesToJSONTyped(value?: HotelRateStreamRates | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'source': value['source'],
        'additional_rates': ((value['additionalRates'] as Array<any>).map(RoomSummaryV3ToJSON)),
        'rates_summary': RatesSummaryToJSON(value['ratesSummary']),
        'recommendation_summary': RecommendationSummaryToJSON(value['recommendationSummary']),
    };
}

